import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockStopAppointment } from '../../use-cases/getOpenDockStopAppointment'

export function useGetOpenDockStopAppointment(
  shipmentUUID: string,
  stopIndex: number,
  enabled: boolean
) {
  const { call, result, status, error } = useAsync(getOpenDockStopAppointment)
  const abortController = useAbortController()

  const fetchOpenDockStopAppointment = useCallback(
    () =>
      call({
        shipmentUUID,
        stopIndex,
        config: abortController,
      }),
    [abortController, call, shipmentUUID, stopIndex]
  )

  useEffect(() => {
    if (enabled) {
      fetchOpenDockStopAppointment()
    }
  }, [enabled, fetchOpenDockStopAppointment])

  return {
    stopAppointment: result,
    status,
    error,
    fetchOpenDockStopAppointment,
  }
}
